/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Free_DescInputs */

const en_directory_submit_review_free_desc = /** @type {(inputs: Directory_Submit_Review_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An editor reviews it, usually within a few days. The link stays nofollow unless you add our badge.`)
};

const zh_directory_submit_review_free_desc = /** @type {(inputs: Directory_Submit_Review_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由编辑审核，通常几天内完成。不挂徽章的话，外链是 nofollow。`)
};

/**
* | output |
* | --- |
* | "An editor reviews it, usually within a few days. The link stays nofollow unless you add our badge." |
*
* @param {Directory_Submit_Review_Free_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_free_desc = /** @type {((inputs?: Directory_Submit_Review_Free_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Free_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_free_desc(inputs)
	return zh_directory_submit_review_free_desc(inputs)
});
export { directory_submit_review_free_desc as "directory.submit.review.free_desc" }